// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/config/v1/identity_config.proto" (package "agency.config.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
/**
 * IdentityConfig configures cryptographic identity primitives for Stage 0.
 * All values externalized - no hardcoded defaults in code.
 *
 * @generated from protobuf message agency.config.v1.IdentityConfig
 */
export interface IdentityConfig {
    /**
     * nats_auth configures NATS authentication (NKey/JWT).
     *
     * @generated from protobuf field: agency.config.v1.NATSAuthConfig nats_auth = 1
     */
    natsAuth?: NATSAuthConfig;
    /**
     * age_encryption configures AGE multi-recipient encryption.
     *
     * @generated from protobuf field: agency.config.v1.AGEEncryptionConfig age_encryption = 2
     */
    ageEncryption?: AGEEncryptionConfig;
    /**
     * sops configures SOPS credential decryption.
     *
     * @generated from protobuf field: agency.config.v1.SOPSConfig sops = 3
     */
    sops?: SOPSConfig;
    /**
     * key_registry configures the NATS KV-backed public key registry.
     *
     * @generated from protobuf field: agency.config.v1.KeyRegistryConfig key_registry = 4
     */
    keyRegistry?: KeyRegistryConfig;
    /**
     * jwt_providers configures per-tenant JWT validation for client authentication.
     * Each tenant has separate IDP configuration (JWKS URL, issuer, audience).
     * Required field - harness fails to start if missing or empty.
     * This validates Layer 1 auth (Client → Harness), distinct from NATS User JWTs.
     *
     * @generated from protobuf field: map<string, agency.config.v1.JWTProviderConfig> jwt_providers = 5
     */
    jwtProviders: {
        [key: string]: JWTProviderConfig;
    };
}
/**
 * NATSAuthConfig configures NATS authentication via NKeys and JWTs.
 *
 * @generated from protobuf message agency.config.v1.NATSAuthConfig
 */
export interface NATSAuthConfig {
    /**
     * mode determines how accounts are managed.
     *
     * @generated from protobuf field: agency.config.v1.AuthMode mode = 1
     */
    mode: AuthMode;
    /**
     * coro configures integration with Coro for account management (mode=CORO_MANAGED).
     *
     * @generated from protobuf field: agency.config.v1.CoroConfig coro = 2
     */
    coro?: CoroConfig;
    /**
     * sops_accounts configures SOPS-only mode for account keys (mode=SOPS_ONLY).
     *
     * @generated from protobuf field: agency.config.v1.SOPSAccountsConfig sops_accounts = 3
     */
    sopsAccounts?: SOPSAccountsConfig;
    /**
     * user_jwt configures User JWT minting settings.
     *
     * @generated from protobuf field: agency.config.v1.UserJWTConfig user_jwt = 4
     */
    userJwt?: UserJWTConfig;
}
/**
 * CoroConfig configures Coro integration for account management.
 *
 * @generated from protobuf message agency.config.v1.CoroConfig
 */
export interface CoroConfig {
    /**
     * api_url is the Coro API endpoint.
     *
     * @generated from protobuf field: string api_url = 1
     */
    apiUrl: string;
    /**
     * namespace_id is the Coro namespace identifier.
     *
     * @generated from protobuf field: string namespace_id = 2
     */
    namespaceId: string;
    /**
     * operator_id is the Coro operator identifier.
     *
     * @generated from protobuf field: string operator_id = 3
     */
    operatorId: string;
    /**
     * sync_interval is how often to refresh account keys from Coro.
     *
     * @generated from protobuf field: google.protobuf.Duration sync_interval = 4
     */
    syncInterval?: Duration;
    /**
     * auth_token_env is the environment variable containing the Coro auth token.
     *
     * @generated from protobuf field: string auth_token_env = 5
     */
    authTokenEnv: string;
}
/**
 * SOPSAccountsConfig configures SOPS-only mode for account keys.
 *
 * @generated from protobuf message agency.config.v1.SOPSAccountsConfig
 */
export interface SOPSAccountsConfig {
    /**
     * accounts_dir is the directory containing SOPS-encrypted account files.
     * Structure: {accounts_dir}/{tenant}/{account_id}.yaml
     *
     * @generated from protobuf field: string accounts_dir = 1
     */
    accountsDir: string;
    /**
     * preload_tenants are tenant IDs to load at startup (fail-fast validation).
     *
     * @generated from protobuf field: repeated string preload_tenants = 2
     */
    preloadTenants: string[];
}
/**
 * UserJWTConfig configures User JWT minting for session actors.
 *
 * @generated from protobuf message agency.config.v1.UserJWTConfig
 */
export interface UserJWTConfig {
    /**
     * default_ttl is the default JWT validity duration.
     *
     * @generated from protobuf field: google.protobuf.Duration default_ttl = 1
     */
    defaultTtl?: Duration;
    /**
     * renew_before_expiry is when to automatically refresh the JWT.
     *
     * @generated from protobuf field: google.protobuf.Duration renew_before_expiry = 2
     */
    renewBeforeExpiry?: Duration;
    /**
     * max_ttl is the maximum allowed TTL for any user JWT.
     *
     * @generated from protobuf field: google.protobuf.Duration max_ttl = 3
     */
    maxTtl?: Duration;
}
/**
 * AGEEncryptionConfig configures AGE X25519 encryption.
 *
 * @generated from protobuf message agency.config.v1.AGEEncryptionConfig
 */
export interface AGEEncryptionConfig {
    /**
     * harness_identity_file is the path to the harness's AGE private key (SOPS-encrypted).
     *
     * @generated from protobuf field: string harness_identity_file = 1
     */
    harnessIdentityFile: string;
    /**
     * ephemeral_key_ttl is the default TTL for session ephemeral keys.
     *
     * @generated from protobuf field: google.protobuf.Duration ephemeral_key_ttl = 2
     */
    ephemeralKeyTtl?: Duration;
    /**
     * max_recipients_per_message limits multi-recipient encryption.
     *
     * @generated from protobuf field: int32 max_recipients_per_message = 3
     */
    maxRecipientsPerMessage: number;
}
/**
 * SOPSConfig configures SOPS decryption for credentials.
 *
 * @generated from protobuf message agency.config.v1.SOPSConfig
 */
export interface SOPSConfig {
    /**
     * credentials_base_path is the root directory for credential files.
     * Structure:
     *   {base_path}/tools/{tenant}/{workspace}/{tool}.yaml
     *   {base_path}/accounts/{tenant}/{account_id}.yaml
     *   {base_path}/llm/{provider}.yaml
     *
     * @generated from protobuf field: string credentials_base_path = 1
     */
    credentialsBasePath: string;
    /**
     * tenant_keys maps tenant IDs to their AGE private key file paths.
     * Each tenant MUST have a separate decryption key for isolation.
     * Keys are loaded at startup and validated against SOPS file recipients.
     * All credentials (tools, accounts, LLM providers) are tenant-scoped.
     * Example: {"acme": "/etc/agency/keys/acme.key", "globex": "/etc/agency/keys/globex.key"}
     *
     * @generated from protobuf field: map<string, string> tenant_keys = 2
     */
    tenantKeys: {
        [key: string]: string;
    };
    /**
     * require_encrypted enforces that all credential files are SOPS-encrypted.
     *
     * @generated from protobuf field: bool require_encrypted = 3
     */
    requireEncrypted: boolean;
    /**
     * preload_workspaces are workspace paths to preload at startup.
     *
     * @generated from protobuf field: repeated agency.config.v1.WorkspacePreload preload_workspaces = 4
     */
    preloadWorkspaces: WorkspacePreload[];
}
/**
 * WorkspacePreload specifies a workspace to preload credentials for.
 *
 * @generated from protobuf message agency.config.v1.WorkspacePreload
 */
export interface WorkspacePreload {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
}
/**
 * KeyRegistryConfig configures the NATS KV-backed public key registry.
 *
 * @generated from protobuf message agency.config.v1.KeyRegistryConfig
 */
export interface KeyRegistryConfig {
    /**
     * bucket_name is the NATS KV bucket for key storage.
     *
     * @generated from protobuf field: string bucket_name = 1
     */
    bucketName: string;
    /**
     * history is the number of historical values to keep per key.
     *
     * @generated from protobuf field: int32 history = 2
     */
    history: number;
    /**
     * replicas is the replication factor for the KV bucket.
     *
     * @generated from protobuf field: int32 replicas = 3
     */
    replicas: number;
    /**
     * key_grace_window is the overlap period during key rotation.
     *
     * @generated from protobuf field: google.protobuf.Duration key_grace_window = 4
     */
    keyGraceWindow?: Duration;
    /**
     * watch_buffer_size is the channel buffer for key change events.
     *
     * @generated from protobuf field: int32 watch_buffer_size = 5
     */
    watchBufferSize: number;
}
/**
 * JWTProviderConfig configures JWT validation for a single tenant.
 * Validates client JWTs (Casdoor/OIDC User tokens) at ingress boundary.
 * Distinct from NATS User JWTs (protocol-level auth, validated by NATS server).
 *
 * @generated from protobuf message agency.config.v1.JWTProviderConfig
 */
export interface JWTProviderConfig {
    /**
     * jwks_url is the OIDC JWKS endpoint URL for this tenant's IDP.
     * Example: "https://auth.acme.com/.well-known/jwks.json"
     * Must be HTTPS in production (HTTP allowed for local dev only).
     *
     * @generated from protobuf field: string jwks_url = 1
     */
    jwksUrl: string;
    /**
     * issuer is the expected 'iss' claim value for this tenant.
     * Tokens with different issuer are rejected.
     * Example: "https://auth.acme.com"
     *
     * @generated from protobuf field: string issuer = 2
     */
    issuer: string;
    /**
     * audience are expected 'aud' claim values for this tenant.
     * Token must have at least one matching audience.
     * Example: ["harness-1", "harness-2", "harness-3"] for federated harnesses.
     *
     * @generated from protobuf field: repeated string audience = 3
     */
    audience: string[];
    /**
     * algorithms are allowed JWT signing algorithms for this tenant.
     * Common values: RS256, RS384, RS512, ES256, ES384, ES512, EdDSA
     * Empty list rejects all tokens (useful for disabling tenant without removing config).
     *
     * @generated from protobuf field: repeated string algorithms = 4
     */
    algorithms: string[];
    /**
     * clock_skew_tolerance allows time drift for exp/nbf/iat validation.
     * Prevents spurious rejections due to clock drift between IDP and harness.
     *
     * @generated from protobuf field: google.protobuf.Duration clock_skew_tolerance = 5
     */
    clockSkewTolerance?: Duration;
    /**
     * jwks_refresh_interval is how often to refetch JWKS from provider.
     * Balances key rotation responsiveness vs IDP load.
     *
     * @generated from protobuf field: google.protobuf.Duration jwks_refresh_interval = 6
     */
    jwksRefreshInterval?: Duration;
    /**
     * jwks_refresh_timeout is the HTTP client timeout for JWKS fetch.
     *
     * @generated from protobuf field: google.protobuf.Duration jwks_refresh_timeout = 7
     */
    jwksRefreshTimeout?: Duration;
    /**
     * jwks_refresh_unknown_kid enables automatic JWKS refresh on unknown key ID.
     * If true: on 'kid not found' error, immediately refetch JWKS once.
     * If false: wait for next scheduled jwks_refresh_interval.
     * Recommended: true (handles key rotation without waiting for interval).
     *
     * @generated from protobuf field: bool jwks_refresh_unknown_kid = 8
     */
    jwksRefreshUnknownKid: boolean;
    /**
     * http_retry_max_attempts is the maximum JWKS fetch retry attempts.
     *
     * @generated from protobuf field: int32 http_retry_max_attempts = 9
     */
    httpRetryMaxAttempts: number;
    /**
     * http_retry_backoff is the backoff duration between retry attempts.
     *
     * @generated from protobuf field: google.protobuf.Duration http_retry_backoff = 10
     */
    httpRetryBackoff?: Duration;
    /**
     * claims_cache_max_entries limits the validated claims cache size for this tenant.
     * Cache stores (sub, exp) pairs to avoid repeated signature validation.
     * On overflow, new entries are dropped and next message re-validates.
     *
     * @generated from protobuf field: int32 claims_cache_max_entries = 11
     */
    claimsCacheMaxEntries: number;
    /**
     * claim_mappings maps internal claim names to JWT claim names.
     * Allows adapting to different IDP claim conventions without code changes.
     * Example: {"tenant": "organization"} reads JWT "organization" claim as tenant.
     * If not specified, defaults to standard claim names (tenant → tenant, etc.).
     * Keys are internal Agency field names, values are JWT claim names from IDP.
     *
     * @generated from protobuf field: map<string, string> claim_mappings = 12
     */
    claimMappings: {
        [key: string]: string;
    };
}
/**
 * AuthMode determines how NATS accounts are managed.
 *
 * @generated from protobuf enum agency.config.v1.AuthMode
 */
export enum AuthMode {
    /**
     * AUTH_MODE_UNSPECIFIED is invalid.
     *
     * @generated from protobuf enum value: AUTH_MODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * AUTH_MODE_CORO_MANAGED fetches account signing keys from Coro at startup.
     *
     * @generated from protobuf enum value: AUTH_MODE_CORO_MANAGED = 1;
     */
    CORO_MANAGED = 1,
    /**
     * AUTH_MODE_SOPS_ONLY loads all account keys from SOPS-encrypted files.
     *
     * @generated from protobuf enum value: AUTH_MODE_SOPS_ONLY = 2;
     */
    SOPS_ONLY = 2,
    /**
     * AUTH_MODE_EMBEDDED generates operator/account locally (dev/testing only).
     *
     * @generated from protobuf enum value: AUTH_MODE_EMBEDDED = 3;
     */
    EMBEDDED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class IdentityConfig$Type extends MessageType<IdentityConfig> {
    constructor() {
        super("agency.config.v1.IdentityConfig", [
            { no: 1, name: "nats_auth", kind: "message", T: () => NATSAuthConfig, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "age_encryption", kind: "message", T: () => AGEEncryptionConfig, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "sops", kind: "message", T: () => SOPSConfig, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "key_registry", kind: "message", T: () => KeyRegistryConfig, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "jwt_providers", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => JWTProviderConfig }, options: { "buf.validate.field": { map: { minPairs: "1", maxPairs: "1000", keys: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<IdentityConfig>): IdentityConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.jwtProviders = {};
        if (value !== undefined)
            reflectionMergePartial<IdentityConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IdentityConfig): IdentityConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.config.v1.NATSAuthConfig nats_auth */ 1:
                    message.natsAuth = NATSAuthConfig.internalBinaryRead(reader, reader.uint32(), options, message.natsAuth);
                    break;
                case /* agency.config.v1.AGEEncryptionConfig age_encryption */ 2:
                    message.ageEncryption = AGEEncryptionConfig.internalBinaryRead(reader, reader.uint32(), options, message.ageEncryption);
                    break;
                case /* agency.config.v1.SOPSConfig sops */ 3:
                    message.sops = SOPSConfig.internalBinaryRead(reader, reader.uint32(), options, message.sops);
                    break;
                case /* agency.config.v1.KeyRegistryConfig key_registry */ 4:
                    message.keyRegistry = KeyRegistryConfig.internalBinaryRead(reader, reader.uint32(), options, message.keyRegistry);
                    break;
                case /* map<string, agency.config.v1.JWTProviderConfig> jwt_providers */ 5:
                    this.binaryReadMap5(message.jwtProviders, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: IdentityConfig["jwtProviders"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof IdentityConfig["jwtProviders"] | undefined, val: IdentityConfig["jwtProviders"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = JWTProviderConfig.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.IdentityConfig.jwt_providers");
            }
        }
        map[key ?? ""] = val ?? JWTProviderConfig.create();
    }
    internalBinaryWrite(message: IdentityConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.config.v1.NATSAuthConfig nats_auth = 1; */
        if (message.natsAuth)
            NATSAuthConfig.internalBinaryWrite(message.natsAuth, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.AGEEncryptionConfig age_encryption = 2; */
        if (message.ageEncryption)
            AGEEncryptionConfig.internalBinaryWrite(message.ageEncryption, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.SOPSConfig sops = 3; */
        if (message.sops)
            SOPSConfig.internalBinaryWrite(message.sops, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.KeyRegistryConfig key_registry = 4; */
        if (message.keyRegistry)
            KeyRegistryConfig.internalBinaryWrite(message.keyRegistry, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, agency.config.v1.JWTProviderConfig> jwt_providers = 5; */
        for (let k of globalThis.Object.keys(message.jwtProviders)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            JWTProviderConfig.internalBinaryWrite(message.jwtProviders[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.IdentityConfig
 */
export const IdentityConfig = new IdentityConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NATSAuthConfig$Type extends MessageType<NATSAuthConfig> {
    constructor() {
        super("agency.config.v1.NATSAuthConfig", [
            { no: 1, name: "mode", kind: "enum", T: () => ["agency.config.v1.AuthMode", AuthMode, "AUTH_MODE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "coro", kind: "message", T: () => CoroConfig },
            { no: 3, name: "sops_accounts", kind: "message", T: () => SOPSAccountsConfig },
            { no: 4, name: "user_jwt", kind: "message", T: () => UserJWTConfig, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<NATSAuthConfig>): NATSAuthConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mode = 0;
        if (value !== undefined)
            reflectionMergePartial<NATSAuthConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NATSAuthConfig): NATSAuthConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.config.v1.AuthMode mode */ 1:
                    message.mode = reader.int32();
                    break;
                case /* agency.config.v1.CoroConfig coro */ 2:
                    message.coro = CoroConfig.internalBinaryRead(reader, reader.uint32(), options, message.coro);
                    break;
                case /* agency.config.v1.SOPSAccountsConfig sops_accounts */ 3:
                    message.sopsAccounts = SOPSAccountsConfig.internalBinaryRead(reader, reader.uint32(), options, message.sopsAccounts);
                    break;
                case /* agency.config.v1.UserJWTConfig user_jwt */ 4:
                    message.userJwt = UserJWTConfig.internalBinaryRead(reader, reader.uint32(), options, message.userJwt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NATSAuthConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.config.v1.AuthMode mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        /* agency.config.v1.CoroConfig coro = 2; */
        if (message.coro)
            CoroConfig.internalBinaryWrite(message.coro, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.SOPSAccountsConfig sops_accounts = 3; */
        if (message.sopsAccounts)
            SOPSAccountsConfig.internalBinaryWrite(message.sopsAccounts, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.UserJWTConfig user_jwt = 4; */
        if (message.userJwt)
            UserJWTConfig.internalBinaryWrite(message.userJwt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.NATSAuthConfig
 */
export const NATSAuthConfig = new NATSAuthConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoroConfig$Type extends MessageType<CoroConfig> {
    constructor() {
        super("agency.config.v1.CoroConfig", [
            { no: 1, name: "api_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256", uri: true } } } },
            { no: 2, name: "namespace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^ns_[a-z0-9_-]+$" } } } },
            { no: 3, name: "operator_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^op_[a-z0-9_-]+$" } } } },
            { no: 4, name: "sync_interval", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "3600" }, gte: { seconds: "60" } } } } },
            { no: 5, name: "auth_token_env", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<CoroConfig>): CoroConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.apiUrl = "";
        message.namespaceId = "";
        message.operatorId = "";
        message.authTokenEnv = "";
        if (value !== undefined)
            reflectionMergePartial<CoroConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoroConfig): CoroConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string api_url */ 1:
                    message.apiUrl = reader.string();
                    break;
                case /* string namespace_id */ 2:
                    message.namespaceId = reader.string();
                    break;
                case /* string operator_id */ 3:
                    message.operatorId = reader.string();
                    break;
                case /* google.protobuf.Duration sync_interval */ 4:
                    message.syncInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.syncInterval);
                    break;
                case /* string auth_token_env */ 5:
                    message.authTokenEnv = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoroConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string api_url = 1; */
        if (message.apiUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.apiUrl);
        /* string namespace_id = 2; */
        if (message.namespaceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.namespaceId);
        /* string operator_id = 3; */
        if (message.operatorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.operatorId);
        /* google.protobuf.Duration sync_interval = 4; */
        if (message.syncInterval)
            Duration.internalBinaryWrite(message.syncInterval, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string auth_token_env = 5; */
        if (message.authTokenEnv !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.authTokenEnv);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.CoroConfig
 */
export const CoroConfig = new CoroConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SOPSAccountsConfig$Type extends MessageType<SOPSAccountsConfig> {
    constructor() {
        super("agency.config.v1.SOPSAccountsConfig", [
            { no: 1, name: "accounts_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "preload_tenants", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SOPSAccountsConfig>): SOPSAccountsConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountsDir = "";
        message.preloadTenants = [];
        if (value !== undefined)
            reflectionMergePartial<SOPSAccountsConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SOPSAccountsConfig): SOPSAccountsConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accounts_dir */ 1:
                    message.accountsDir = reader.string();
                    break;
                case /* repeated string preload_tenants */ 2:
                    message.preloadTenants.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SOPSAccountsConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accounts_dir = 1; */
        if (message.accountsDir !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accountsDir);
        /* repeated string preload_tenants = 2; */
        for (let i = 0; i < message.preloadTenants.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.preloadTenants[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.SOPSAccountsConfig
 */
export const SOPSAccountsConfig = new SOPSAccountsConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserJWTConfig$Type extends MessageType<UserJWTConfig> {
    constructor() {
        super("agency.config.v1.UserJWTConfig", [
            { no: 1, name: "default_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "86400" }, gte: { seconds: "60" } } } } },
            { no: 2, name: "renew_before_expiry", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "3600" }, gte: { seconds: "30" } } } } },
            { no: 3, name: "max_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "604800" }, gte: { seconds: "60" } } } } }
        ]);
    }
    create(value?: PartialMessage<UserJWTConfig>): UserJWTConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UserJWTConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserJWTConfig): UserJWTConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration default_ttl */ 1:
                    message.defaultTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.defaultTtl);
                    break;
                case /* google.protobuf.Duration renew_before_expiry */ 2:
                    message.renewBeforeExpiry = Duration.internalBinaryRead(reader, reader.uint32(), options, message.renewBeforeExpiry);
                    break;
                case /* google.protobuf.Duration max_ttl */ 3:
                    message.maxTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.maxTtl);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserJWTConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration default_ttl = 1; */
        if (message.defaultTtl)
            Duration.internalBinaryWrite(message.defaultTtl, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration renew_before_expiry = 2; */
        if (message.renewBeforeExpiry)
            Duration.internalBinaryWrite(message.renewBeforeExpiry, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration max_ttl = 3; */
        if (message.maxTtl)
            Duration.internalBinaryWrite(message.maxTtl, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.UserJWTConfig
 */
export const UserJWTConfig = new UserJWTConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AGEEncryptionConfig$Type extends MessageType<AGEEncryptionConfig> {
    constructor() {
        super("agency.config.v1.AGEEncryptionConfig", [
            { no: 1, name: "harness_identity_file", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "ephemeral_key_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "86400" }, gte: { seconds: "60" } } } } },
            { no: 3, name: "max_recipients_per_message", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<AGEEncryptionConfig>): AGEEncryptionConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessIdentityFile = "";
        message.maxRecipientsPerMessage = 0;
        if (value !== undefined)
            reflectionMergePartial<AGEEncryptionConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AGEEncryptionConfig): AGEEncryptionConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string harness_identity_file */ 1:
                    message.harnessIdentityFile = reader.string();
                    break;
                case /* google.protobuf.Duration ephemeral_key_ttl */ 2:
                    message.ephemeralKeyTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.ephemeralKeyTtl);
                    break;
                case /* int32 max_recipients_per_message */ 3:
                    message.maxRecipientsPerMessage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AGEEncryptionConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string harness_identity_file = 1; */
        if (message.harnessIdentityFile !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.harnessIdentityFile);
        /* google.protobuf.Duration ephemeral_key_ttl = 2; */
        if (message.ephemeralKeyTtl)
            Duration.internalBinaryWrite(message.ephemeralKeyTtl, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 max_recipients_per_message = 3; */
        if (message.maxRecipientsPerMessage !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxRecipientsPerMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.AGEEncryptionConfig
 */
export const AGEEncryptionConfig = new AGEEncryptionConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SOPSConfig$Type extends MessageType<SOPSConfig> {
    constructor() {
        super("agency.config.v1.SOPSConfig", [
            { no: 1, name: "credentials_base_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "tenant_keys", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { minPairs: "1", maxPairs: "1000", keys: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } }, values: { string: { minLen: "1", maxLen: "4096" } } } } } },
            { no: 3, name: "require_encrypted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "preload_workspaces", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WorkspacePreload, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } }
        ]);
    }
    create(value?: PartialMessage<SOPSConfig>): SOPSConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialsBasePath = "";
        message.tenantKeys = {};
        message.requireEncrypted = false;
        message.preloadWorkspaces = [];
        if (value !== undefined)
            reflectionMergePartial<SOPSConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SOPSConfig): SOPSConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credentials_base_path */ 1:
                    message.credentialsBasePath = reader.string();
                    break;
                case /* map<string, string> tenant_keys */ 2:
                    this.binaryReadMap2(message.tenantKeys, reader, options);
                    break;
                case /* bool require_encrypted */ 3:
                    message.requireEncrypted = reader.bool();
                    break;
                case /* repeated agency.config.v1.WorkspacePreload preload_workspaces */ 4:
                    message.preloadWorkspaces.push(WorkspacePreload.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: SOPSConfig["tenantKeys"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SOPSConfig["tenantKeys"] | undefined, val: SOPSConfig["tenantKeys"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.SOPSConfig.tenant_keys");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SOPSConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credentials_base_path = 1; */
        if (message.credentialsBasePath !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.credentialsBasePath);
        /* map<string, string> tenant_keys = 2; */
        for (let k of globalThis.Object.keys(message.tenantKeys))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.tenantKeys[k]).join();
        /* bool require_encrypted = 3; */
        if (message.requireEncrypted !== false)
            writer.tag(3, WireType.Varint).bool(message.requireEncrypted);
        /* repeated agency.config.v1.WorkspacePreload preload_workspaces = 4; */
        for (let i = 0; i < message.preloadWorkspaces.length; i++)
            WorkspacePreload.internalBinaryWrite(message.preloadWorkspaces[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.SOPSConfig
 */
export const SOPSConfig = new SOPSConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkspacePreload$Type extends MessageType<WorkspacePreload> {
    constructor() {
        super("agency.config.v1.WorkspacePreload", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkspacePreload>): WorkspacePreload {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        if (value !== undefined)
            reflectionMergePartial<WorkspacePreload>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkspacePreload): WorkspacePreload {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkspacePreload, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.WorkspacePreload
 */
export const WorkspacePreload = new WorkspacePreload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeyRegistryConfig$Type extends MessageType<KeyRegistryConfig> {
    constructor() {
        super("agency.config.v1.KeyRegistryConfig", [
            { no: 1, name: "bucket_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9._-]*[a-z0-9]$" } } } },
            { no: 2, name: "history", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 64, gte: 1 } } } },
            { no: 3, name: "replicas", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 5, gte: 1 } } } },
            { no: 4, name: "key_grace_window", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "86400" }, gte: { seconds: "60" } } } } },
            { no: 5, name: "watch_buffer_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<KeyRegistryConfig>): KeyRegistryConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bucketName = "";
        message.history = 0;
        message.replicas = 0;
        message.watchBufferSize = 0;
        if (value !== undefined)
            reflectionMergePartial<KeyRegistryConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KeyRegistryConfig): KeyRegistryConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string bucket_name */ 1:
                    message.bucketName = reader.string();
                    break;
                case /* int32 history */ 2:
                    message.history = reader.int32();
                    break;
                case /* int32 replicas */ 3:
                    message.replicas = reader.int32();
                    break;
                case /* google.protobuf.Duration key_grace_window */ 4:
                    message.keyGraceWindow = Duration.internalBinaryRead(reader, reader.uint32(), options, message.keyGraceWindow);
                    break;
                case /* int32 watch_buffer_size */ 5:
                    message.watchBufferSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KeyRegistryConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string bucket_name = 1; */
        if (message.bucketName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.bucketName);
        /* int32 history = 2; */
        if (message.history !== 0)
            writer.tag(2, WireType.Varint).int32(message.history);
        /* int32 replicas = 3; */
        if (message.replicas !== 0)
            writer.tag(3, WireType.Varint).int32(message.replicas);
        /* google.protobuf.Duration key_grace_window = 4; */
        if (message.keyGraceWindow)
            Duration.internalBinaryWrite(message.keyGraceWindow, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 watch_buffer_size = 5; */
        if (message.watchBufferSize !== 0)
            writer.tag(5, WireType.Varint).int32(message.watchBufferSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.KeyRegistryConfig
 */
export const KeyRegistryConfig = new KeyRegistryConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JWTProviderConfig$Type extends MessageType<JWTProviderConfig> {
    constructor() {
        super("agency.config.v1.JWTProviderConfig", [
            { no: 1, name: "jwks_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048", uri: true } } } },
            { no: 2, name: "issuer", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512", uri: true } } } },
            { no: 3, name: "audience", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "20", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 4, name: "algorithms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "2", maxLen: "16", pattern: "^[A-Z][A-Z0-9]+$" } } } } } },
            { no: 5, name: "clock_skew_tolerance", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "300" }, gte: {} } } } },
            { no: 6, name: "jwks_refresh_interval", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "86400" }, gte: { seconds: "300" } } } } },
            { no: 7, name: "jwks_refresh_timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "60" }, gte: { seconds: "5" } } } } },
            { no: 8, name: "jwks_refresh_unknown_kid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "http_retry_max_attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 1 } } } },
            { no: 10, name: "http_retry_backoff", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { lte: { seconds: "60" }, gte: { seconds: "1" } } } } },
            { no: 11, name: "claims_cache_max_entries", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000000, gte: 100 } } } },
            { no: 12, name: "claim_mappings", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z_][a-z0-9_]*$" } }, values: { string: { minLen: "1", maxLen: "128" } } } } } }
        ]);
    }
    create(value?: PartialMessage<JWTProviderConfig>): JWTProviderConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.jwksUrl = "";
        message.issuer = "";
        message.audience = [];
        message.algorithms = [];
        message.jwksRefreshUnknownKid = false;
        message.httpRetryMaxAttempts = 0;
        message.claimsCacheMaxEntries = 0;
        message.claimMappings = {};
        if (value !== undefined)
            reflectionMergePartial<JWTProviderConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JWTProviderConfig): JWTProviderConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string jwks_url */ 1:
                    message.jwksUrl = reader.string();
                    break;
                case /* string issuer */ 2:
                    message.issuer = reader.string();
                    break;
                case /* repeated string audience */ 3:
                    message.audience.push(reader.string());
                    break;
                case /* repeated string algorithms */ 4:
                    message.algorithms.push(reader.string());
                    break;
                case /* google.protobuf.Duration clock_skew_tolerance */ 5:
                    message.clockSkewTolerance = Duration.internalBinaryRead(reader, reader.uint32(), options, message.clockSkewTolerance);
                    break;
                case /* google.protobuf.Duration jwks_refresh_interval */ 6:
                    message.jwksRefreshInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.jwksRefreshInterval);
                    break;
                case /* google.protobuf.Duration jwks_refresh_timeout */ 7:
                    message.jwksRefreshTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.jwksRefreshTimeout);
                    break;
                case /* bool jwks_refresh_unknown_kid */ 8:
                    message.jwksRefreshUnknownKid = reader.bool();
                    break;
                case /* int32 http_retry_max_attempts */ 9:
                    message.httpRetryMaxAttempts = reader.int32();
                    break;
                case /* google.protobuf.Duration http_retry_backoff */ 10:
                    message.httpRetryBackoff = Duration.internalBinaryRead(reader, reader.uint32(), options, message.httpRetryBackoff);
                    break;
                case /* int32 claims_cache_max_entries */ 11:
                    message.claimsCacheMaxEntries = reader.int32();
                    break;
                case /* map<string, string> claim_mappings */ 12:
                    this.binaryReadMap12(message.claimMappings, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap12(map: JWTProviderConfig["claimMappings"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof JWTProviderConfig["claimMappings"] | undefined, val: JWTProviderConfig["claimMappings"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.JWTProviderConfig.claim_mappings");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: JWTProviderConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string jwks_url = 1; */
        if (message.jwksUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.jwksUrl);
        /* string issuer = 2; */
        if (message.issuer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.issuer);
        /* repeated string audience = 3; */
        for (let i = 0; i < message.audience.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.audience[i]);
        /* repeated string algorithms = 4; */
        for (let i = 0; i < message.algorithms.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.algorithms[i]);
        /* google.protobuf.Duration clock_skew_tolerance = 5; */
        if (message.clockSkewTolerance)
            Duration.internalBinaryWrite(message.clockSkewTolerance, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration jwks_refresh_interval = 6; */
        if (message.jwksRefreshInterval)
            Duration.internalBinaryWrite(message.jwksRefreshInterval, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration jwks_refresh_timeout = 7; */
        if (message.jwksRefreshTimeout)
            Duration.internalBinaryWrite(message.jwksRefreshTimeout, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool jwks_refresh_unknown_kid = 8; */
        if (message.jwksRefreshUnknownKid !== false)
            writer.tag(8, WireType.Varint).bool(message.jwksRefreshUnknownKid);
        /* int32 http_retry_max_attempts = 9; */
        if (message.httpRetryMaxAttempts !== 0)
            writer.tag(9, WireType.Varint).int32(message.httpRetryMaxAttempts);
        /* google.protobuf.Duration http_retry_backoff = 10; */
        if (message.httpRetryBackoff)
            Duration.internalBinaryWrite(message.httpRetryBackoff, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* int32 claims_cache_max_entries = 11; */
        if (message.claimsCacheMaxEntries !== 0)
            writer.tag(11, WireType.Varint).int32(message.claimsCacheMaxEntries);
        /* map<string, string> claim_mappings = 12; */
        for (let k of globalThis.Object.keys(message.claimMappings))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.claimMappings[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.JWTProviderConfig
 */
export const JWTProviderConfig = new JWTProviderConfig$Type();
